import { Select } from "@chakra-ui/react";
import { RegisterOptions, useFormContext } from "react-hook-form";
import { BaseFormControl } from "./abstractions/base-form-control";

interface FormDropdownProps {
  name: string;
  label: string;
  placeholder?: string;
  rules?: RegisterOptions;
  options: string[];
  isReadOnly?: boolean;
}

export function FormDropdown({
  name,
  label,
  options,
  rules,
  isReadOnly,
  placeholder,
}: FormDropdownProps) {
  const { register } = useFormContext();

  const getPlaceholder = () => {
    if (placeholder) return placeholder;
    return "Select an option";
  };

  return (
    <BaseFormControl
      name={name}
      label={label}
      isRequired={!!rules?.required}
      isDisabled={!!rules?.disabled}
      isReadOnly={isReadOnly}
    >
      <Select placeholder={getPlaceholder()} variant="primary" {...register(name, rules)}>
        {options?.map((option: string) => (
          <option key={option} value={option} style={{ textTransform: "capitalize" }}>
            {option}
          </option>
        ))}
      </Select>
    </BaseFormControl>
  );
}
